import React from 'react';

import BackgroundImage from 'components/Toolbar/Shared/BackgroundImage';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { BackgroundImageProps } from './models';
import styles from './styles.module.scss';

const BackgroundImageDropdown: React.FunctionComponent<BackgroundImageProps> = (props) => {
  const { dataTestId = 'backgroundImage' } = props;

  return (
    <Dropdown className={styles.BackgroundImage} stopClickPropagation={true} dataTestId={`${dataTestId}-dropdown`}>
      <BackgroundImage {...props} />
    </Dropdown>
  );
};

export default BackgroundImageDropdown;
